import * as yup from "yup";

export const createEditOtaHmacValidator = yup.object({
  aota_pkg_version: yup.string().required("Field is required"),
  hmac_secret_b64url: yup.string().required("Field is required"),
});
